window.MHBuilderInit = function (DATA) {
  'use strict';

/* Which sports the search offers, and which of them we can already draw.
   It lives with the artwork in assets/mh-icons.json, so adding a sport is a
   change to one small data file rather than a new copy of this library.
   An entry with no slug has no figures yet: choosing it offers to have one
   drawn, which is a better answer than not being found at all. */
const CATALOGUE = DATA.catalogue || [];

  const ICONS = {};
  DATA.icons.forEach(i => ICONS[i.id] = i);
  /* ---------------------------------------------------------------
     Two languages.

     The customer reads the builder in English or in Arabic and the page
     turns around with them. What the ORDER carries stays English — the
     figure names, the lettering, the properties the workshop reads — so
     the designer's sheets do not change with a customer's preference.

     The wording itself lives in assets/mh-i18n.json, fetched beside the
     figures, so a change of copy never means re-uploading the library.
     --------------------------------------------------------------- */
  const I18N      = DATA.i18n || {};
  const STR       = I18N.STR || { en: {}, ar: {} };
  const GROUP_AR  = I18N.GROUP_AR || {};
  const SPORT_AR  = I18N.SPORT_AR || {};
  const SET_AR    = I18N.SET_AR || {};
  const ICON_AR   = I18N.ICON_AR || {};

  let LANG = 'en';
  function t(key, vars) {
    let s = (STR[LANG] && STR[LANG][key]);
    if (s === undefined) s = STR.en[key];
    if (s === undefined) return key;
    if (vars) for (const k in vars) s = s.split('{' + k + '}').join(vars[k]);
    return s;
  }
  /* Arabic copy is written with Arabic-Indic numerals, so any number we
     drop into it has to match, or one sentence carries both ١٠ and 10.
     Prices are the exception — they come from Shopify's money filter
     and stay Western. */
  function num(v) {
    return LANG === 'ar'
      ? String(v).replace(/[0-9]/g, function (d) { return '٠١٢٣٤٥٦٧٨٩'[+d]; })
      : String(v);
  }
  /* Variant labels arrive as '104 cm'. In Arabic both the digits and the
     unit have to change; a digit swap alone leaves '١٠٤ cm'. Display only —
     the order sheet must keep the English label. */
  function sizeLabel(v) {
    var s = String(v);
    return LANG === 'ar' ? num(s).replace(/\s*cm\b/i, ' سم') : s;
  }
  /* Arabic-Indic zero is itself a dot, so a ' · ' separator beside a numeral
     merges into it — '· ١٠٤' reads as ٠١٠٤. Arabic separates with a comma. */
  function sep() {
    return LANG === 'ar' ? '، ' : ' · ';
  }
  /* Attribute separator vs list separator: sep() divides unlike things
     ('104 cm · 26.100 KD'), listSep() joins like ones ('Runner, Cyclist'). */
  function listSep() {
    return LANG === 'ar' ? '، ' : ', ';
  }
  /* "1 figure" / "2 figures" in English; Arabic has a dual form, so 1 and 2
     are words rather than a number and a word. */
  function figuresN(n, bold) {
    const b = function (x) { return bold ? '<b>' + x + '</b>' : String(x); };
    if (LANG === 'ar') {
      if (n === 1) return b('شكل واحد');
      if (n === 2) return b('شكلان');
      return b(num(n)) + ' ' + (n <= 10 ? 'أشكال' : 'شكلًا');
    }
    return b(n) + ' ' + (n === 1 ? 'figure' : 'figures');
  }
  function sportName(en) { return LANG === 'ar' ? (SPORT_AR[en] || en) : en; }
  function groupName(en) { return LANG === 'ar' ? (GROUP_AR[en] || en) : en; }
  function setLabel(set) { return LANG === 'ar' ? (SET_AR[set.slug] || set.label) : set.label; }
  function iconName(id) {
    if (id === CUSTOM_ID) return (state.custom && state.custom.sport) || t('customFigure');
    const ic = ICONS[id] || {};
    return LANG === 'ar' ? (ICON_AR[id] || ic.label || id) : (ic.label || id);
  }

  /* Swap the language: the words, the direction, and everything script has
     already written to the page. */
  function applyLang(lang) {
    LANG = lang === 'ar' ? 'ar' : 'en';
    ROOT.setAttribute('lang', LANG);
    ROOT.setAttribute('dir', LANG === 'ar' ? 'rtl' : 'ltr');
    ROOT.querySelectorAll('[data-i18n]').forEach(function (el) {
      el.innerHTML = t(el.getAttribute('data-i18n'));
    });
    ROOT.querySelectorAll('[data-i18n-ph]').forEach(function (el) {
      el.placeholder = t(el.getAttribute('data-i18n-ph'));
    });
    /* The name field's placeholder follows the face, not the declared key. */
    nameInput.placeholder = namePlaceholder();
    ROOT.querySelectorAll('[data-lang]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.lang === LANG));
    });
    buildChips(); buildSizes(); buildColours();
    /* The search box says how many sports there are, so its placeholder is
       built rather than declared and has to be rebuilt with the language. */
    sportSearch.placeholder = t('searchPh', { n: num(FLAT.length) });
    renderSports(); renderIcons(); draw();
    if (ORDER[state.step] === 'done') renderSummary();
    const cnt = $('#nameCount');
    if (cnt && !cnt.hidden) cnt.textContent = t('counter', { n: num(45 - nameInput.value.length) });
    const add = $('#mhAddPrice');
    if (add) add.textContent = priceFor(state.size, state.colour) || '';
  }

  function initLang() {
    /* Follow the page language, English otherwise. Deliberately not
       remembered between visits: the switch is for this visit only, so the
       builder always opens in the language of the site around it. */
    const l = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0 ? 'ar' : 'en';
    ROOT.querySelectorAll('[data-lang]').forEach(function (b) {
      b.addEventListener('click', function () { applyLang(b.dataset.lang); });
    });
    applyLang(l);
  }


  const SHOP = window.MH_PRODUCT || { variants: [] };
  function variantFor(size, colour) {
    return SHOP.variants.filter(function (v) {
      return v.size === size && v.colour === colour;
    })[0] || null;
  }
  /* The price shown in the builder is the price the cart will charge: same
     variant, same number, so nothing changes under the customer at checkout. */
  function priceFor(size, colour) {
    var v = variantFor(size, colour);
    return v ? v.price : '';
  }
  const SIZES = [
    { id: '104', label: '104 cm', get note() { return t('size104note'); },
      get price() { return priceFor('104', 'black'); } },
    { id: '53',  label: '53 cm',  get note() { return t('size53note'); },
      get price() { return priceFor('53', 'black'); } }
  ];
  /* Lettering. Marquisette is the real cutting face; the other two are
     stand-ins chosen for the same reason a cutting font has to be chosen —
     even stroke weight and joined letters, so nothing drops out of the sheet.
     Swap in the real ones when they're licensed. */
  /* Width of the thinnest stroke each face draws, in millimetres per 100 mm
     of type size, measured off the real outlines by measure_stroke.js. It is
     what tells the builder how small a name is allowed to get before the
     laser can no longer hold it. Regenerate whenever a face changes.
     The arabic row was measured off Amiri; the Arabic face is now Cairo cut
     as a stencil, which needs neither number (see looseMarks and draw). */
  const STROKE = {"deco":{"stroke_per100":6.333,"thinnest":"w","marks":{"-":1,"'":1}},"script":{"stroke_per100":10,"thinnest":"e","marks":{"i":1,"j":1,"-":1,"'":1}},"arabic":{"stroke_per100":4,"thinnest":"ٌ","marks":{"أ":1,"آ":1,"ت":1,"ث":2,"خ":1,"ذ":1,"ز":1,"ش":2,"ض":1,"ظ":1,"غ":1,"ف":1,"ق":1,"ك":1,"ن":1,"ؤ":1,"ئ":1,"ة":1,"ً":2,"ٌ":1,"َ":1,"ُ":1,"ّ":1,"ْ":1,"-":1}}};
  const FONTS = [
    { id: 'deco',   get label() { return t('fDeco'); },   get sample() { return t('sampleLatin'); },  css: '"Marquisette BTN", Georgia, serif', track: 1, rtl: false },
    { id: 'script', get label() { return t('fScript'); }, get sample() { return t('sampleLatin'); },  css: 'Pacifico, cursive',                 track: 0, rtl: false },
    { id: 'arabic', get label() { return t('fArabic'); }, get sample() { return t('sampleArabic'); }, css: 'Cairo, "Noto Naskh Arabic", sans-serif', track: 0, rtl: true  }
  ].map(f => { f.stroke = (STROKE[f.id] || {}).stroke_per100 || 5; return f; });
  /* Each face cuts one script. The Latin faces have no Arabic outlines and
     the Arabic face has no Latin ones, so a letter from the other script is
     not a style choice but a glyph the laser cannot follow. These are the
     letters each face cannot take, as global patterns so they can be
     stripped as well as tested. Digits, spaces, punctuation and emoji pass:
     the Arabic block also holds the Arabic-Indic digits, the Arabic comma,
     semicolon, question mark and full stop, and those are skipped so that
     "١٠٤" survives in every face. Letters and combining marks
     from the Arabic block, Supplement, Extended-A and both Presentation
     Forms blocks are what is dropped. Likewise × and ÷ are left out of
     the Latin range. */
  const ARABIC_CHARS = /[ؐ-ؚؠ-ٟٮ-ۓە-ۜ۟-۪ۨ-ۯۺ-ۼۿݐ-ݿࢠ-ࣿﭐ-ﴽ﵀-﷿ﹰ-ﻼ]/g;
  const LATIN_CHARS  = /[A-Za-zÀ-ÖØ-öø-ɏ]/g;
  function disallowedFor(faceId) { return faceId === 'arabic' ? LATIN_CHARS : ARABIC_CHARS; }
  /* A global pattern remembers where its last match ended; reset before
     every test so a stale position can never hide a real match. */
  function has(re, s) { re.lastIndex = 0; return re.test(s); }
  function cleanFor(faceId, value) {
    const v = String(value == null ? '' : value);
    const cleaned = v.replace(disallowedFor(faceId), '');
    return { value: cleaned, removed: v.length - cleaned.length };
  }

  const COLOURS = [
    { id: 'black',  get label() { return t('cBlack'); },  hex: '#17161B' },
    { id: 'white',  get label() { return t('cWhite'); },  hex: '#F7F6F2' },
    { id: 'gold',   get label() { return t('cGold'); },   hex: '#B08A2E' },
    { id: 'silver', get label() { return t('cSilver'); }, hex: '#9DA1A6' }
  ];

  const ORDER = ['intro', 'name', 'sport', 'icons', 'size', 'colour', 'done'];
  const state = { step: 0, name: '', sport: null, sportName: null, font: 'deco',
                  icons: [], sel: null, size: '104', colour: 'black',
                  custom: null };

  /* Escapes customer-typed text before it is written into HTML.
     Lives here, high up and next to the other helpers, because a previous
     edit wiped it when it sat mid-file inside a replaced block. */
  function esc(t) {
    return String(t == null ? '' : t).replace(/[<>&"']/g, c =>
      ({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  const $  = s => document.querySelector(s);
  const $$ = s => Array.from(document.querySelectorAll(s));

  const svg       = $('#hanger');
  const iconLayer = $('#iconLayer');
  const nameText  = $('#nameText');
  const wrap      = $('#hangerWrap');
  /* The builder's own root. Custom properties must be set HERE: the
     stylesheet declares --metal on this element, so a value set further
     up the tree is overridden by it and the steel never changes colour. */
  const ROOT      = svg.closest('.mh-builder-root') || document.documentElement;
  /* On a phone the page itself scrolls and the preview is pinned; the rules
     that do that live in the stylesheet and in initScroll() below. */
  const MOBILE    = window.matchMedia('(max-width: 860px)');
  const REDUCED   = window.matchMedia('(prefers-reduced-motion: reduce)');
  let rootTop = 0;                    // the builder's offset down the page

  /* ---------------------------------------------------------------
     Preview. Everything is drawn in millimetres at 1:1, which is why
     the same geometry can drive both this and the cutting file.
     --------------------------------------------------------------- */
  const SHAPES = {"53":{"d":"M 1679 944.667969 C 1675.867188 944.667969 1673.332031 942.128906 1673.332031 939 C 1673.332031 935.867188 1675.867188 933.332031 1679 933.332031 C 1682.132812 933.332031 1684.671875 935.867188 1684.671875 939 C 1684.671875 942.128906 1682.132812 944.667969 1679 944.667969 M 1679 1169.667969 C 1675.867188 1169.667969 1673.332031 1167.128906 1673.332031 1164 C 1673.332031 1160.867188 1675.867188 1158.332031 1679 1158.332031 C 1682.132812 1158.332031 1684.671875 1160.867188 1684.671875 1164 C 1684.671875 1167.128906 1682.132812 1169.667969 1679 1169.667969 M 1652.996094 945.894531 C 1650.121094 961.882812 1637.160156 972.8125 1620.515625 972.855469 L 1025.835938 973.199219 C 1014.152344 973.210938 1004.644531 968.667969 998.128906 959.046875 C 991.039062 948.582031 990.074219 937.140625 996.113281 925.917969 C 1002.507812 914.039062 1012.960938 908.449219 1026.488281 908.457031 C 1106.152344 908.515625 1185.816406 908.542969 1265.480469 908.5625 C 1383.476562 908.589844 1501.472656 908.582031 1619.46875 908.6875 C 1623.898438 908.695312 1628.59375 908.992188 1632.714844 910.445312 C 1647.445312 915.632812 1655.753906 930.582031 1652.996094 945.894531 M 1651.863281 1051.773438 C 1650.566406 1069.199219 1636.894531 1082.125 1619.523438 1082.195312 L 1023.996094 1082.765625 C 1007.238281 1082.652344 993.71875 1069.972656 992.027344 1053.476562 C 990.417969 1037.769531 1001.289062 1023.089844 1017.539062 1019.507812 L 1621.445312 1018.664062 C 1639.1875 1018.65625 1653.183594 1034.046875 1651.863281 1051.773438 M 1650.101562 1164.238281 C 1647.304688 1179.554688 1634.152344 1191.144531 1619.136719 1191.242188 L 1005.4375 1185.902344 C 994.070312 1177.941406 989.164062 1163.542969 993.328125 1150.570312 C 997.640625 1137.140625 1010.402344 1128.167969 1025.476562 1128.160156 L 1619.4375 1128.230469 C 1623.1875 1128.226562 1627.15625 1128.832031 1630.65625 1130.140625 C 1644.359375 1135.273438 1652.671875 1150.164062 1650.101562 1164.238281 M 962.667969 1057.628906 C 959.539062 1057.628906 957 1055.09375 957 1051.960938 C 957 1048.832031 959.539062 1046.292969 962.667969 1046.292969 C 965.800781 1046.292969 968.339844 1048.832031 968.339844 1051.960938 C 968.339844 1055.09375 965.800781 1057.628906 962.667969 1057.628906 M 898.476562 1082.652344 L 302.292969 1081.71875 C 284.144531 1081.660156 269.941406 1066.4375 270.207031 1047.796875 C 270.445312 1030.902344 284.628906 1017.703125 302.390625 1017.765625 C 315.890625 1017.8125 329.390625 1017.789062 342.890625 1017.777344 C 416.886719 1017.722656 490.882812 1017.667969 564.882812 1017.589844 L 624.234375 1017.972656 C 671.566406 1018.066406 718.898438 1018.125 766.230469 1018.226562 C 809.730469 1018.324219 853.226562 1018.457031 896.726562 1018.574219 C 910.03125 1018.613281 920.414062 1024.148438 926.65625 1035.917969 C 937.882812 1057.097656 922.773438 1082.171875 898.476562 1082.652344 M 929.257812 1167.613281 C 925.714844 1182.351562 912.644531 1191.890625 895.613281 1191.878906 C 851.613281 1191.84375 807.617188 1191.707031 763.621094 1191.605469 L 305.652344 1190.761719 C 286.472656 1190.765625 271.972656 1176.25 272.214844 1157.738281 C 272.445312 1140.339844 287.070312 1127.085938 305.441406 1127.140625 L 896.898438 1128.136719 C 918.804688 1128.21875 934.1875 1147.117188 929.257812 1167.613281 M 272.558594 923.191406 C 279.171875 911.769531 289.597656 907.269531 302.734375 907.320312 C 379.230469 907.601562 455.726562 907.664062 532.226562 907.753906 C 653.390625 907.902344 774.554688 908.007812 895.71875 908.160156 C 915.699219 908.183594 930.296875 922.230469 930.226562 941.203125 C 930.160156 959.425781 915.386719 973.09375 895.773438 973.066406 L 301.355469 971.949219 C 276.085938 971.863281 260.066406 944.769531 272.558594 923.191406 M 245 944.671875 C 241.867188 944.671875 239.332031 942.132812 239.332031 939.003906 C 239.332031 935.871094 241.867188 933.332031 245 933.332031 C 248.132812 933.332031 250.671875 935.871094 250.671875 939.003906 C 250.671875 942.132812 248.132812 944.671875 245 944.671875 M 245 1169.671875 C 241.867188 1169.671875 239.332031 1167.132812 239.332031 1164.003906 C 239.332031 1160.871094 241.867188 1158.335938 245 1158.335938 C 248.132812 1158.335938 250.671875 1160.871094 250.671875 1164.003906 C 250.671875 1167.132812 248.132812 1169.671875 245 1169.671875 M 1691.53125 999.390625 C 1689.417969 996.59375 1689.355469 994.6875 1691.550781 992.03125 C 1705.453125 975.1875 1710.929688 955.65625 1710.347656 934 C 1709.261719 893.859375 1676.539062 861.875 1636.40625 861.984375 L 284.804688 861.675781 C 264.707031 861.671875 247.503906 869.21875 233.085938 883.136719 C 204.304688 910.917969 206.9375 958.050781 226.488281 985.847656 C 228.679688 988.960938 232.535156 992.027344 232.601562 995.179688 C 232.667969 998.300781 228.902344 1001.496094 226.839844 1004.671875 C 207.824219 1033.953125 209.875 1072.1875 231.972656 1100.476562 C 233.886719 1102.925781 236.175781 1104.777344 233.15625 1108.515625 C 220.132812 1124.65625 214.9375 1143.351562 215.832031 1163.976562 C 217.382812 1199.679688 243.046875 1229.839844 278.210938 1235.820312 L 1631.988281 1237.921875 C 1650.304688 1237.878906 1666.882812 1231.613281 1680.464844 1219.453125 C 1712.097656 1191.144531 1716.382812 1144.386719 1690.855469 1110.492188 C 1688.078125 1106.804688 1687.761719 1104.609375 1690.773438 1100.757812 C 1714.625 1070.292969 1714.855469 1030.230469 1691.53125 999.390625 ","fill_rule":"evenodd","minx":211.63197326660156,"miny":861.67578125,"w_mm":528.728,"h_mm":132.731,"k":0.35277777777777775,"rail_mm":16.25,"top_mm":0},"104":{"d":"M 3436.867188 774.003906 C 3424.644531 834.886719 3274.265625 824.867188 3274.265625 824.867188 L 2066.75 824.867188 L 2066.75 692.132812 L 3285.738281 692.53125 C 3285.738281 692.53125 3424.644531 682.117188 3436.867188 742.996094 Z M 3380.703125 848.839844 C 3377.570312 848.839844 3375.035156 846.300781 3375.035156 843.167969 C 3375.035156 840.039062 3377.570312 837.5 3380.703125 837.5 C 3383.832031 837.5 3386.371094 840.039062 3386.371094 843.167969 C 3386.371094 846.300781 3383.832031 848.839844 3380.703125 848.839844 M 2019.9375 765.730469 C 2016.808594 765.730469 2014.269531 763.191406 2014.269531 760.058594 C 2014.269531 756.929688 2016.808594 754.390625 2019.9375 754.390625 C 2023.070312 754.390625 2025.605469 756.929688 2025.605469 760.058594 C 2025.605469 763.191406 2023.070312 765.730469 2019.9375 765.730469 M 1969.816406 824.867188 L 773.617188 824.867188 C 773.617188 824.867188 623.238281 834.886719 611.015625 774.003906 L 611.015625 742.996094 C 623.238281 682.117188 773.617188 692.132812 773.617188 692.132812 L 1969.816406 692.132812 Z M 674.0625 848.898438 C 670.929688 848.898438 668.394531 846.359375 668.394531 843.226562 C 668.394531 840.097656 670.929688 837.5625 674.0625 837.5625 C 677.191406 837.5625 679.730469 840.097656 679.730469 843.226562 C 679.730469 846.359375 677.191406 848.898438 674.0625 848.898438 M 674.0625 667.246094 C 677.191406 667.246094 679.730469 669.785156 679.730469 672.917969 C 679.730469 676.046875 677.191406 678.585938 674.0625 678.585938 C 670.929688 678.585938 668.394531 676.046875 668.394531 672.917969 C 668.394531 669.785156 670.929688 667.246094 674.0625 667.246094 M 3380.703125 667.1875 C 3383.832031 667.1875 3386.371094 669.726562 3386.371094 672.855469 C 3386.371094 675.988281 3383.832031 678.527344 3380.703125 678.527344 C 3377.570312 678.527344 3375.035156 675.988281 3375.035156 672.855469 C 3375.035156 669.726562 3377.570312 667.1875 3380.703125 667.1875 M 3366.792969 649.136719 L 696.902344 647.230469 C 568.292969 659.027344 546.214844 701.5 547.441406 725.738281 L 547.9375 800.703125 C 552.574219 829.988281 597.136719 872.890625 771.617188 872.890625 L 3274.265625 872.890625 C 3448.746094 872.890625 3495.304688 829.988281 3499.941406 800.703125 L 3500.4375 725.738281 C 3501.605469 702.664062 3479.84375 663.0625 3366.792969 649.136719 ","fill_rule":"nonzero","minx":547.3944091796875,"miny":647.23046875,"w_mm":1041.783,"h_mm":79.608,"k":0.35277777777777775,"rail_mm":15.25,"top_mm":0.5}};
  let BAR_TOP = 95;   // set per size from the real template height

  /* Without a viewport meta a phone lays the page out at 980px and the
     mobile breakpoint never fires. The artifact skeleton normally supplies
     one; this is the belt-and-braces. */
  if (!document.querySelector('meta[name=viewport]')) {
    const m = document.createElement('meta');
    m.name = 'viewport';
    m.content = 'width=device-width, initial-scale=1, viewport-fit=cover';
    document.head.appendChild(m);
  }

  /* ---------------------------------------------------------------
     Ink measurement, by rendering.

     measureText's actualBoundingBox values proved unstable for Arabic —
     the same string returned 39 then 31 between calls — so instead the
     text is drawn to an offscreen canvas and the pixels are scanned for
     the topmost and bottommost row carrying ink. Slower, cached, and
     it cannot disagree with what the customer sees.
     --------------------------------------------------------------- */
  const _mcv = document.createElement('canvas');
  const _mctx = _mcv.getContext('2d', { willReadFrequently: true });
  const _mcache = {};
  const PROBE_FS = 100, PROBE_BASE = 260;

  function inkMetrics(text, css) {
    const key = css + '|' + text;
    if (_mcache[key]) return _mcache[key];
    let r = { asc: 70, desc: 0 };
    try {
      _mctx.font = '700 ' + PROBE_FS + 'px ' + css;
      const w = Math.ceil(_mctx.measureText(text).width) + 120;
      _mcv.width = Math.max(200, Math.min(4000, w));
      _mcv.height = 420;
      _mctx.font = '700 ' + PROBE_FS + 'px ' + css;   // resizing resets state
      _mctx.textBaseline = 'alphabetic';
      _mctx.fillStyle = '#000';
      _mctx.clearRect(0, 0, _mcv.width, _mcv.height);
      _mctx.fillText(text, 40, PROBE_BASE);

      const d = _mctx.getImageData(0, 0, _mcv.width, _mcv.height).data;
      let top = -1, bot = -1;
      for (let y = 0; y < _mcv.height; y++) {
        const row = y * _mcv.width * 4;
        for (let x = 3; x < _mcv.width * 4; x += 4) {
          if (d[row + x] > 12) { if (top < 0) top = y; bot = y; break; }
        }
      }
      if (top >= 0) {
        /* Also where the ink starts and ends across the line, relative to the
           start of the advance, so the stencil's band can follow the word's
           real ink rather than its advance box. */
        const inkAt = x => { for (let y = top; y <= bot; y++) if (d[(y * _mcv.width + x) * 4 + 3] > 12) return true; return false; };
        let left = 0, right = _mcv.width - 1;
        while (left < _mcv.width - 1 && !inkAt(left)) left++;
        while (right > 0 && !inkAt(right)) right--;
        r = { asc: PROBE_BASE - top, desc: Math.max(0, bot - PROBE_BASE),
              left: left - 40, right: right + 1 - 40 };
      }
    } catch (e) {}
    if (!r.asc) r = { asc: 70, desc: 0 };
    _mcache[key] = r;
    return r;
  }

  function metal() {
    return (COLOURS.find(c => c.id === state.colour) || COLOURS[0]).hex;
  }

  function setTint(hex) {
    const r = parseInt(hex.slice(1, 3), 16) / 255,
          g = parseInt(hex.slice(3, 5), 16) / 255,
          b = parseInt(hex.slice(5, 7), 16) / 255;
    $('#tintMatrix').setAttribute('values',
      `0 0 0 0 ${r}  0 0 0 0 ${g}  0 0 0 0 ${b}  0 0 0 1 0`);
  }

  /* The library was never drawn to one height. A swimmer's ink fills a fifth
     of its 400 x 400 canvas and an obstacle racer's fills 86% of it, so
     sizing every figure by its canvas puts a full-height racer beside a
     sliver of a swimmer and makes the sliver look like a mistake. Each icon
     now ships the box its drawing actually occupies, and figures are sized
     so their DRAWINGS match — at the library's median height, so the
     typical figure is unchanged and only the outliers move.

     Height alone is not enough: a swimmer is horizontal, so matching its
     height to a standing runner's would stretch it across a third of the
     bar. WIDE_CAP is the ceiling on how far a low, wide figure may spread. */
  const MED_INK  = 0.69;    // median ink height across the 59 icons
  const WIDE_CAP = 1.30;    // widest a figure may run, relative to the slot
  /* How far a figure is pulled toward a common height. 0 leaves every icon
     exactly as drawn; 1 makes every drawing the same height.

     It is 0, because that is what the workshop does. Across the six finished
     production files the icon canvas sits at a near-constant height — 115 to
     126 mm on the 104 — and the swimmer, whose ink fills only a fifth of its
     canvas, sits right on that median at 24.8 mm tall. The designers do not
     enlarge it. The one exception is the football on #5124, nudged up on its
     own; that is a judgement about a small round object, not a rule.

     This was 0.5, which made the swimmer look better on screen than the
     hanger the customer would open. A preview that flatters is worse than a
     preview that is plain. */
  const BALANCE = 0;
  const DEFAULT_INK = { x: 0.15, y: 0.14, w: 0.7, h: 0.69 };   // the placeholder
  const inkOf = id => (ICONS[id] && ICONS[id].ink) || DEFAULT_INK;
  // the ink height this figure is drawn at, after the pull
  const targetInk = k => k.h * Math.pow(MED_INK / k.h, BALANCE);
  /* Width the figure will occupy, as a multiple of the slot height — the
     same number the layout budgets with and the placement scales by. */
  const widthFactor = id => {
    const k = inkOf(id);
    return Math.min(targetInk(k) * k.w / k.h, WIDE_CAP);
  };

  function draw() {
    const size = SIZES.find(s => s.id === state.size);
    const S = SHAPES[state.size];
    const W = S.w_mm;

    // Figures stand in a zone above the bar; the bar itself is the exact
    // outline from the workshop template, dropped in at 1:1 millimetres.
    /* The height the icon's 400 x 400 canvas is drawn at.
       Measured off six finished production files (#5120-#5125): the designers
       place the canvas at a median 124 mm on the 104 and 108 mm on the 53.
       The builder had been using 82 and 74, which made every figure about
       40% smaller than the hanger the customer actually receives. */
    const baseH = state.size === '53' ? 108 : 124;
    BAR_TOP = baseH + 10;
    svg.setAttribute('viewBox', `0 0 ${W} ${BAR_TOP + S.h_mm}`);
    wrap.classList.toggle('small', state.size === '53');

    $('#barPath').setAttribute('d', S.d);
    $('#barPath').setAttribute('fill-rule', S.fill_rule);
    $('#barGroup').setAttribute('transform',
      `translate(${-S.minx * S.k} ${BAR_TOP - S.miny * S.k}) scale(${S.k})`);

    // proportional margins, taken from the real bar width
    const PAD = W * 0.045;
    const GAP = W * 0.033;
    const SPLIT = W * 0.012;

    const c = metal();
    ROOT.style.setProperty('--metal', c);
    /* White steel on the white wall all but disappears, so for a white hanger
       the wall turns dark (see .wall-dark in the stylesheet). Keyed off the
       colour's id, not its hex. */
    ROOT.classList.toggle('wall-dark', state.colour === 'white');
    // true relative scale between the two bars, straight from the templates
    ROOT.style.setProperty(
      '--size-ratio', (SHAPES['53'].w_mm / SHAPES['104'].w_mm).toFixed(4));
    setTint(c);
    /* White on the pale wall needed a hairline to stay legible. The wall now
       goes dark for white and the stylesheet drops the hairline on screen;
       the attribute stays because the order PNG, a standalone SVG that no
       stylesheet reaches, has always carried it. */
    $('#hangerBody').setAttribute('stroke', state.colour === 'white' ? '#CFC5B2' : 'none');
    $('#hangerBody').setAttribute('stroke-width', state.colour === 'white' ? '1.5' : '0');

    /* ---- balance the name against the figures ----
       This is the "we will adjust the size of text and icons for a balanced
       look" line, done arithmetically: hold the figures at a readable size
       and give the name whatever room is left, rather than letting a long
       name shrink the figures into specks. */
    const label = state.name || '';   // small caps live in the lowercase slots
    const ids = state.icons;
    const nL = leftCount(ids.length);
    const left = ids.slice(0, nL), right = ids.slice(nL);
    const maxN = Math.max(left.length, right.length, 1);
    const sum = arr => arr.reduce((t, id) => t + widthFactor(id), 0);
    const maxWF = Math.max(sum(left), sum(right), 1);

    nameText.textContent = label;
    nameText.setAttribute('x', W / 2);
    nameText.setAttribute('y', BAR_TOP);   // provisional; corrected once fs settles

    /* Every face has a different cap height, so size from what actually
       renders rather than from a number tuned to one font. */
    const face = FONTS.find(f => f.id === state.font) || FONTS[0];
    nameText.setAttribute('font-family', face.css);
    nameText.setAttribute('font-weight', face.id === 'script' ? '400' : '700');
    nameText.setAttribute('letter-spacing', face.track);
    nameText.setAttribute('direction', face.rtl ? 'rtl' : 'ltr');

    /* Target the ink height ABOVE the baseline. Descenders are allowed to
       run down into the bar — that is what makes it one cut piece — so it
       is the ascent that decides how big the name looks next to the figures.
       getBBox() reports the em box rather than the ink, so measure on a
       canvas, which gives true ink bounds per face. */
    /* Sizing across two scripts is not one formula.
       Latin is sized on the face's cap height, measured from an "H" probe,
       so every name in a face gets the same cap regardless of which letters
       it happens to contain — "Maya" and "Salma" come out the same size.
       Ascenders may stand a little above the target, and descenders run
       into the steel and are trimmed there (see the clip below), so neither
       makes the word smaller. Deco is all caps, so its result is unchanged.
       Arabic is different: in
       "أسامه" the hamza-topped alef reaches 102
       units while the letter bodies are only 39, so matching total ink makes
       the readable part a third of the size. Arabic is therefore sized on its
       BODY — measured from a probe with no ascenders — at roughly 55% of the
       Latin cap, which is the conventional optical balance between them. */
    /* Cap height for the name, as a ceiling the fit loop comes down from.
       Also measured off the production files: 64 mm on the 104 (ABDULAZIZ at
       nine letters and Sultan almheiri at fifteen both land there), 52 mm on
       the 53. Longer names shrink from here, exactly as the designers do it —
       Mohammed bin salem, at eighteen letters, comes out around 50 mm. */
    const TARGET_INK  = state.size === '53' ? 52 : 64;   // Latin: ascent
    const TARGET_BODY = state.size === '53' ? 27 : 32;   // Arabic: letter bodies

    /* ---- how the lettering joins the bar ----
       The hanger leaves the laser as ONE piece. A letter that merely touches
       the top edge is a letter that drops out of the sheet, so the baseline
       is set BELOW the edge: every glyph standing on it overlaps real steel.

       The dip has a ceiling. Measured off the workshop templates, the band
       of steel under the top edge is 15.25 mm on the 104 and 16.25 mm on
       the 53, flat and unbroken across the middle of the bar where the name
       sits. Ink may sink into that band but must leave a web underneath —
       3 mm, the same minimum the laser holds anywhere else — or the letter
       cuts clean through and the bar comes apart. */
    const TOP    = BAR_TOP + S.top_mm;        // the top surface under the name
    const CLEAR  = 3;                         // web of steel that must survive
    const BUDGET = S.rail_mm - CLEAR;         // total depth ink may occupy
    /* How deep a glyph on the baseline sits inside the steel.

       This started at 5 mm and that was wrong: on a 50 mm cap it swallowed the
       bottom of every letter — the S lost its lower curve, the A lost its feet.
       Depth is not what makes the joint strong. The joint is as wide as the
       letter's stem, which in the Deco face is 6.3 mm; the overlap only has to
       be enough that the two outlines MERGE rather than kiss, which is a
       question of drawing tolerance and laser kerf, not of structure. A
       millimetre and a half is ten times the kerf and 3% of a cap height —
       unmistakably one piece, and invisible. */
    const WELD_MAX = 1.5, WELD_MIN = 0.8;
    const FIG_WELD = 2.0;                     // the figures, which have feet not curves

    /* The builder never limits a layout: the workshop can always make the real
       hanger work, so whatever is asked for is drawn, smaller if need be.
       FS_MIN is only about a name standing alone staying legible, in the
       drawing's own units (millimetres); past it the name still shrinks
       rather than run off the ends of the bar. */
    const FS_MIN = 12;

    /* ---- the Arabic stencil ----
       The workshop cuts an Arabic name the other way round from a Latin one:
       the letters are holes in the steel, inside a thick outline that follows
       the word, and the outline's foot runs into a flat band that stands the
       word on the bar (#5084, #5129). So every dot is a hole with steel all
       round it and nothing is loose. The outline is the text's own stroke,
       half of which falls outside the letters: on #5084 the steel outside a
       letter is 1.06 of a stem, Cairo 700's stem is 0.13 of its size, so the
       whole stroke is 2 x 1.06 x 0.13 = 0.27 of the size. */
    const STENCIL = face.id === 'arabic' && !!label;
    const SW_K = 0.27;                        // stroke width / font size
    const BAND_IN = 1.5;                      // band sinks this far into the bar, mm

    let fs = 72, ink = { asc: 70, desc: 0 };
    if (label) {
      ink = inkMetrics(label, face.css);
      /* Arabic sizing applies to Arabic. A name that mixes scripts — "Ali
         علي" — is dominated by its Latin, so it takes the Latin rule. */
      if (face.rtl && !/[A-Za-z]/.test(label)) {
        /* "سم" is all body — no ascender, no rising loop. Final ه looks like
           a body letter but its loop rises, which is why it measured wrong. */
        const body = inkMetrics('سم', face.css).asc;
        fs = body > 0 ? TARGET_BODY * 100 / body : 60;
      } else {
        const cap = inkMetrics('H', face.css).asc;
        if (cap > 0) fs = TARGET_INK * 100 / cap;
        else if (ink.asc > 0) fs = TARGET_INK * 100 / ink.asc;
      }
      /* A tall alef is allowed to stand higher than the figures — that is
         what the artwork actually does. The canvas grows to fit it below. */
    }

    let tw = 0, h = baseH, nameHalf = 0;

    if (!ids.length) {
      /* Name alone may run wider. 0.97 per pass: 160 passes take any
         starting size well below FS_MIN. */
      for (let guard = 0; guard < 160; guard++) {
        nameText.setAttribute('font-size', fs);
        tw = label ? nameText.getComputedTextLength() : 0;
        const twS = tw + (STENCIL ? SW_K * fs : 0);         // with the stencil's outline
        if (twS > W * 0.66 && fs > FS_MIN) { fs = Math.max(FS_MIN, fs * 0.97); continue; }
        if (twS > W - 2 * PAD) { fs *= 0.97; continue; }     // never past the ends
        break;
      }
    } else {
      /* Name and figures scale together, by one factor s, so their proportion
         stays constant however long the name: a long name makes the whole
         design smaller rather than a tiny name between full-size figures.
         (This replaces the rule, taken from #5121, that the figures got their
         size first and the name yielded.) Both start from their natural size,
         fs0 and h0, and s is the largest factor at which the busier side
         fits: name half, GAP, the figures' widths (h times their width
         factors, as place() lays them out), the gaps between them and PAD
         must come to half the bar.
         Text length is not quite proportional to the size: letter-spacing is
         a fixed length per letter. So it is measured at two sizes and split
         into the part that scales (a) and the part that does not (b). */
      const fs0 = fs, h0 = baseH;
      let a = 0, b = 0;
      if (label) {
        nameText.setAttribute('font-size', fs0 / 2);
        const halfLen = nameText.getComputedTextLength();
        nameText.setAttribute('font-size', fs0);
        const tw0 = nameText.getComputedTextLength();
        a = 2 * (tw0 - halfLen);
        b = tw0 - a;
        /* The stencil's outline adds SW_K x fs of steel across the word, half
           each side, and grows with the type like the letters do. */
        if (STENCIL) a += SW_K * fs0;
      }
      const gapN = label ? GAP : 0;
      const room = W / 2 - gapN - PAD - (maxN - 1) * SPLIT - b / 2;
      let s = Math.min(1, room / (a / 2 + maxWF * h0));
      s = Math.max(s, 0.1);                   // sanity floor only; no warning
      fs = fs0 * s;
      h = h0 * s;
      nameText.setAttribute('font-size', fs);
      tw = label ? nameText.getComputedTextLength() : 0;
      /* Belt and braces against rounding in the measurement: the figures
         never take more than the room the name actually leaves. */
      const twF = tw + (STENCIL ? SW_K * fs : 0);
      const fitH = ((W / 2 - (twF ? twF / 2 + GAP : 0)) - PAD - (maxN - 1) * SPLIT) / maxWF;
      if (h > fitH) h = Math.max(h0 * 0.1, fitH);
    }
    const SW = STENCIL ? SW_K * fs : 0;
    nameHalf = tw ? (tw + SW) / 2 + GAP : 0;

    /* Set the baseline inside the steel. A face with no descent — the small
       caps — welds by the full WELD_MAX; a face that hangs below the
       baseline gives some of that depth back to its own tail, down to
       WELD_MIN, so the deepest ink still stops short of the underside. */
    let weld = WELD_MAX;
    if (STENCIL) {
      /* The stencil does not sink into the bar. Its lowest ink sits SW/2
         above the bar top, so the outline under it lands exactly on the bar,
         and the band below the baseline stands the whole word on it. */
      nameText.setAttribute('y', TOP - SW / 2 - ink.desc * fs / 100);
    } else if (label) {
      const descMm = ink.desc * fs / 100;
      weld = Math.max(WELD_MIN, Math.min(WELD_MAX, BUDGET - descMm));
      nameText.setAttribute('y', TOP + weld);
    }

    /* Trim the tail rather than shrink the word. Ink inside the steel is
       invisible — same piece, same colour — so a descender may run into the
       bar as deep as the budget allows and simply stop there, which is what
       the workshop does with a script name. The viewBox is millimetres at
       1:1 and the clip is in user units, so its floor is TOP + BUDGET
       exactly. Wider than the bar on purpose: only the bottom edge cuts.
       Built once and reused; the preview clones the whole SVG, so the
       order's PNG carries the same trim. */
    let clip = svg.querySelector('#mhNameClip');
    if (!clip) {
      let defs = svg.querySelector('defs');
      if (!defs) {
        defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        svg.insertBefore(defs, svg.firstChild);
      }
      clip = document.createElementNS('http://www.w3.org/2000/svg', 'clipPath');
      clip.setAttribute('id', 'mhNameClip');
      clip.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'rect'));
      defs.appendChild(clip);
    }
    const clipRect = clip.querySelector('rect');
    clipRect.setAttribute('x', -10000);
    clipRect.setAttribute('y', -10000);
    clipRect.setAttribute('width', W + 20000);
    clipRect.setAttribute('height', TOP + BUDGET + 10000);
    if (STENCIL) nameText.removeAttribute('clip-path');
    else nameText.setAttribute('clip-path', 'url(#mhNameClip)');

    /* The stencil. The name and a band under it share one group, masked by
       the name itself: a mask rather than a wall-coloured fill, because the
       hanger is tinted and the wall may be pale or dark, and the holes have
       to show the real wall. The name is stroked in the metal to make the
       outline; the mask takes the letters back out. Built once and reused;
       the order's PNG clones the SVG, mask and all. */
    const SVGNS = 'http://www.w3.org/2000/svg';
    let nameGroup = svg.querySelector('#mhNameGroup');
    if (!nameGroup) {
      nameGroup = document.createElementNS(SVGNS, 'g');
      nameGroup.setAttribute('id', 'mhNameGroup');
      nameText.parentNode.insertBefore(nameGroup, nameText);
      const bandEl = document.createElementNS(SVGNS, 'rect');
      bandEl.setAttribute('id', 'mhArBand');
      bandEl.setAttribute('fill', 'var(--metal)');
      nameGroup.appendChild(bandEl);
      nameGroup.appendChild(nameText);
    }
    let mask = svg.querySelector('#mhArMask');
    if (!mask) {
      mask = document.createElementNS(SVGNS, 'mask');
      mask.setAttribute('id', 'mhArMask');
      mask.setAttribute('maskUnits', 'userSpaceOnUse');
      mask.setAttribute('x', -10000);
      mask.setAttribute('y', -10000);
      mask.setAttribute('width', 30000);
      mask.setAttribute('height', 30000);
      const all = document.createElementNS(SVGNS, 'rect');
      all.setAttribute('x', -10000);
      all.setAttribute('y', -10000);
      all.setAttribute('width', 30000);
      all.setAttribute('height', 30000);
      all.setAttribute('fill', '#fff');
      const holes = document.createElementNS(SVGNS, 'text');
      holes.setAttribute('id', 'mhArHoles');
      holes.setAttribute('fill', '#000');
      holes.setAttribute('text-anchor', 'middle');
      holes.setAttribute('text-rendering', 'geometricPrecision');
      mask.append(all, holes);
      svg.querySelector('defs').appendChild(mask);
    }
    const band = nameGroup.querySelector('#mhArBand');
    if (STENCIL) {
      /* Drawn small, as on a phone, Chrome paints text at a rounded size and
         its glyphs drift from where the layout put them, so the letters, the
         holes and the band stop lining up. Exact geometry keeps all three on
         the same outlines. */
      nameText.setAttribute('text-rendering', 'geometricPrecision');
      nameText.setAttribute('stroke', 'var(--metal)');
      nameText.setAttribute('stroke-width', SW);
      nameText.setAttribute('stroke-linejoin', 'miter');
      nameText.setAttribute('stroke-miterlimit', 2);
      const holes = mask.querySelector('#mhArHoles');
      ['x', 'y', 'font-size', 'font-family', 'font-weight', 'direction', 'letter-spacing']
        .forEach(a => holes.setAttribute(a, nameText.getAttribute(a)));
      holes.textContent = label;
      /* The band runs under the word's ink, out to the outline either side,
         from the baseline down into the bar: on #5084 and #5129 the steel
         under the letters is solid to the bar, and the dots below the line
         are holes in it, not letters hanging over a gap. */
      const x0 = W / 2 - tw / 2;
      const inkL = x0 + (ink.left != null ? ink.left : 0) * fs / 100;
      const inkR = ink.right != null ? x0 + ink.right * fs / 100 : x0 + tw;
      band.setAttribute('x', inkL - SW / 2);
      band.setAttribute('width', inkR - inkL + SW);
      const base = +nameText.getAttribute('y');
      band.setAttribute('y', base);
      band.setAttribute('height', TOP - base + BAND_IN);
      band.removeAttribute('display');
      nameGroup.setAttribute('mask', 'url(#mhArMask)');
    } else {
      ['stroke', 'stroke-width', 'stroke-linejoin', 'stroke-miterlimit', 'text-rendering'].forEach(a => nameText.removeAttribute(a));
      band.setAttribute('display', 'none');
      nameGroup.removeAttribute('mask');
    }

    // ---- place the figures either side ----
    iconLayer.textContent = '';
    let inkTopMost = Infinity;      // the highest ink on the bar, for the frame
    if (ids.length) {
      const place = (arr, x0, x1) => {
        if (!arr.length) return;
        const widths = arr.map(id => h * widthFactor(id));
        const total = widths.reduce((a, b) => a + b, 0);
        const slack = Math.max(0, (x1 - x0) - total);
        const gap = arr.length > 1 ? slack / (arr.length - 1) : 0;
        // hug the name: start from the outer edge inward
        let x = x0 + (arr.length > 1 ? 0 : slack / 2);
        arr.forEach((id, i) => {
          const k = inkOf(id);
          /* Side of the square image box. Sized so the DRAWING lands at the
             common height, unless that would make a wide figure spread past
             the cap, in which case its width decides. */
          const s = Math.min(h * targetInk(k) / k.h, h * WIDE_CAP / k.w);
          const im = document.createElementNS('http://www.w3.org/2000/svg', 'image');
          im.setAttribute('href', ICONS[id].src);
          // put the DRAWING at x, not the canvas it happens to sit in
          im.setAttribute('x', x - s * k.x);
          /* The figures weld the same way the letters do. Every icon in the
             library is drawn with its feet on the bottom edge of the canvas,
             so resting that edge exactly on the bar left the figure tangent
             to it — touching, joined by nothing. Sunk by FIG_WELD it shares
             real material with the bar. Measured off the ink, so a figure
             that does not quite reach its canvas edge still sinks in.
             A shade deeper than the lettering: a runner meets the bar on the
             soles of two shoes, so there is less contact to merge, and a
             figure has no fine bottom detail to lose. */
          im.setAttribute('y', TOP + FIG_WELD - s * (k.y + k.h));
          im.setAttribute('width', s);
          im.setAttribute('height', s);
          im.setAttribute('filter', 'url(#tint)');
          if (id === CUSTOM_ID) im.setAttribute('opacity', '0.45');
          iconLayer.appendChild(im);
          inkTopMost = Math.min(inkTopMost, TOP + FIG_WELD - s * k.h);
          x += widths[i] + gap;
        });
      };
      place(left,  PAD, W / 2 - nameHalf);
      place(right, W / 2 + nameHalf, W - PAD);
    }

    /* Frame the drawing on what is actually in it. The figures are placed
       relative to a canvas whose height is a constant, but their ink fills
       anything from a fifth of that canvas to nearly all of it, so a fixed
       frame leaves a swimmer sitting under a hand's width of nothing. */
    if (label) {
      inkTopMost = Math.min(inkTopMost,
        (+nameText.getAttribute('y')) - ink.asc * fs / 100 - SW / 2);
    }
    const top = Math.min(BAR_TOP, isFinite(inkTopMost) ? inkTopMost - 6 : BAR_TOP);
    svg.setAttribute('viewBox', `0 ${top} ${W} ${BAR_TOP + S.h_mm - top}`);

    // wall caption + empty state
    const filled = state.name || state.icons.length;
    /* A variable, not an inline opacity: on a phone the caption also fades
       with the scroll, and an inline value would override that rule. */
    $('#stageEmpty').style.setProperty('--mh-empty', filled ? '0' : '1');
    $('#hangerBody').style.opacity = filled ? 1 : 0.13;

    /* No "won't fit" notice: the designers can always make the layout work,
       so the builder does not warn. The element and its strings stay, unused. */
    $('#stageFit').hidden = true;

    $('#stageMeta').innerHTML = filled ? [
      `<span>${t('metaWide', { s: '<b>' + sizeLabel(size.label) + '</b>' })}</span>`,
      `<span>${t('metaSteel', { c: '<b>' + (COLOURS.find(x => x.id === state.colour) || {}).label + '</b>' })}</span>`,
      `<span>${figuresN(state.icons.length, true)}</span>`,
      `<span>${t('metaThick')}</span>`
    ].join('') : '';

    /* The screen-reader description of the preview. Set as textContent, so
       no markup: bidi isolation would be read aloud, not applied. */
    $('#hangerDesc').textContent = filled
      ? t('hangerDesc', { size: sizeLabel(size.label),
                          colour: (COLOURS.find(x => x.id === state.colour) || {}).label,
                          n: figuresN(state.icons.length),
                          name: state.name || t('hangerDescNoName') })
      : t('hangerDescEmpty');
  }

  /* ---------------------------------------------------------------
     Steps
     --------------------------------------------------------------- */
  function go(i) {
    const was = state.step;
    state.step = Math.max(0, Math.min(ORDER.length - 1, i));
    const key = ORDER[state.step];
    $$('.step').forEach(s => s.classList.toggle('on', s.dataset.step === key));
    $('#bar').style.width = (state.step / (ORDER.length - 1) * 100) + '%';
    $('#steps').scrollTop = 0;            // the desktop panel's own scroller
    if (key === 'done') renderSummary();
    /* On a phone the page scrolls: start every new question at the top of
       the builder, under the full-size preview. Only on a real change, so
       the boot call and a repeated step never jump the page. */
    if (state.step !== was && MOBILE.matches) {
      window.scrollTo({ top: rootTop, behavior: REDUCED.matches ? 'auto' : 'smooth' });
    }
    const focusable = $(`.step.on input, .step.on .choice, .step.on .ibtn, .step.on .sw, .step.on .btn`);
    if (focusable && window.innerWidth > 860) {
      setTimeout(() => { try { focusable.focus({ preventScroll: true }); } catch (e) {} }, 240);
    }
  }

  function next() { go(state.step + 1); }
  function back() { go(state.step - 1); }

  document.addEventListener('click', e => {
    if (e.target.closest('[data-next]')) { if (!e.target.closest('[data-next]').disabled) next(); }
    else if (e.target.closest('[data-back]')) back();
  });

  /* name */
  const nameInput = $('#nameInput');

  /* lettering chips, under the name field */
  const fontChips = $('#fontChips');
  function buildChips() {
  fontChips.textContent = '';
  FONTS.forEach(f => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'fchip';
    b.setAttribute('role', 'radio');
    b.dataset.font = f.id;
    b.setAttribute('aria-checked', String(f.id === state.font));
    const sample = document.createElement('span');
    sample.textContent = f.sample;
    sample.style.fontFamily = f.css;      /* never via an HTML attribute — the
                                             stack contains double quotes */
    sample.style.fontWeight = '700';      /* match the weight the bar cuts at */
    if (f.rtl) sample.setAttribute('dir', 'rtl');
    const tag = document.createElement('small');
    tag.textContent = f.label;
    b.append(sample, tag);
    b.addEventListener('click', () => setFont(f.id, true));
    fontChips.appendChild(b);
  });
  refreshChipSamples();
  }
  /* Each chip shows the customer's own name in that face, so the choice is
     made on the real word rather than on a sample. Only where the name can
     be cut in that face at all: a name with letters the face cannot take
     falls back to the neutral sample. */
  function refreshChipSamples() {
    const name = nameInput.value;
    Array.from(fontChips.children).forEach(function (c) {
      const f = FONTS.find(function (x) { return x.id === c.dataset.font; });
      const s = c.querySelector('span');
      if (!f || !s) return;
      s.textContent = name.trim() && !cleanFor(f.id, name).removed ? name : f.sample;
    });
  }
  buildChips();

  /* Told, not silently corrected: when a letter is dropped the reason
     appears under the field, and goes away by itself or with the next
     keystroke that drops nothing. Built here rather than in the section so
     the markup stays a JS-only change. */
  const scriptHint = document.createElement('p');
  scriptHint.className = 'hint scripthint';
  scriptHint.id = 'nameScriptHint';
  scriptHint.hidden = true;
  scriptHint.style.cssText = 'color:#A42325;margin:.4rem 0 0';
  $('#nameCount').insertAdjacentElement('afterend', scriptHint);
  let hintTimer = null;
  function hideScriptHint() {
    if (hintTimer) { clearTimeout(hintTimer); hintTimer = null; }
    scriptHint.hidden = true;
  }
  function showScriptHint(faceId) {
    scriptHint.textContent = t(faceId === 'arabic' ? 'scriptArabicOnly' : 'scriptLatinOnly');
    scriptHint.hidden = false;
    if (hintTimer) clearTimeout(hintTimer);
    hintTimer = setTimeout(hideScriptHint, 4000);
  }
  /* Strip what the face cannot cut from the field, keeping the caret where
     the customer left it: it moves back by exactly the number of dropped
     letters that stood before it. */
  function applyScript(faceId) {
    const raw = nameInput.value;
    const out = cleanFor(faceId, raw);
    if (!out.removed) { hideScriptHint(); return; }
    const at = nameInput.selectionStart == null ? raw.length : nameInput.selectionStart;
    let keptBefore = cleanFor(faceId, raw.slice(0, at)).value.length;
    /* Taking every letter away can leave the spaces between them; that is
       not a name, so the field is emptied outright. */
    if (!out.value.trim()) { out.value = ''; keptBefore = 0; }
    nameInput.value = out.value;
    try { nameInput.setSelectionRange(keptBefore, keptBefore); } catch (e) {}
    showScriptHint(faceId);
  }
  /* Everything that follows from the field's value: state, the counter,
     the button, the chips, the strip and the preview. */
  function syncName() {
    state.name = nameInput.value;
    /* A counter that greets you at zero reads as a scold. It appears only
       as the limit comes into view, and explains the limit rather than
       just asserting it — the bar is only so long. */
    const n = nameInput.value.length;
    const cnt = $('#nameCount');
    const LIMIT = 45;
    cnt.hidden = n < 30;
    cnt.textContent = t('counter', { n: num(LIMIT - n) });
    cnt.classList.toggle('warn', n > 40);
    $('#nameNext').disabled = !nameInput.value.trim();
    refreshChipSamples();
    renderStrip();
    draw();
  }

  /* The prompt in the field is written in the script the chosen face cuts. */
  function namePlaceholder() {
    return t(state.font === 'arabic' ? 'q1PhAr' : 'q1Ph');
  }
  function setFont(id, manual) {
    state.font = id;
    if (manual) state.fontLocked = true;
    const face = FONTS.find(f => f.id === id) || FONTS[0];
    Array.from(fontChips.children).forEach(c =>
      c.setAttribute('aria-checked', String(c.dataset.font === id)));
    nameInput.style.fontFamily = face.css;
    nameInput.setAttribute('dir', face.rtl ? 'rtl' : 'auto');
    nameInput.placeholder = namePlaceholder();
    /* A face chosen by hand takes the name with it: letters it cannot cut
       are dropped, and the customer is told why. */
    if (manual) { applyScript(id); syncName(); return; }
    refreshChipSamples();
    renderStrip();
    draw();
  }
  nameInput.addEventListener('input', () => {
    /* A bilingual store should not make an Arabic name ask for an Arabic
       font. The first letters decide, and only while the customer has not
       chosen a face by hand: Arabic alone picks the Arabic face, Latin alone
       picks Deco, and a mix leaves the face where it is, so a Latin name
       is never thrown onto the Arabic face by one stray letter. */
    if (!state.fontLocked) {
      const raw = nameInput.value;
      const hasAr = has(ARABIC_CHARS, raw), hasLa = has(LATIN_CHARS, raw);
      let wants = state.font;
      if (hasAr && !hasLa) wants = 'arabic';
      else if (hasLa && !hasAr) wants = 'deco';
      if (wants !== state.font) setFont(wants, false);
    }
    applyScript(state.font);
    syncName();
  });

  /* ---------------------------------------------------------------
     Custom figure. The generated image is a BRIEF, not a cut file —
     a designer redraws every one before it reaches the laser. Saying
     that plainly is what lets the sketch be rough without the customer
     feeling short-changed, and it is what the workshop needs recorded.
     --------------------------------------------------------------- */
  const CUSTOM_ID = '__custom';
  /* A deliberately generic figure. It holds the position and shows the
     layout without pretending to be artwork of their sport — the whole
     promise here is that a person draws the real one. */
  const PLACEHOLDER = 'data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20400%20400%22%3E%3Cg%20fill%3D%22%23000%22%3E%3Ccircle%20cx%3D%22200%22%20cy%3D%2260%22%20r%3D%2240%22%2F%3E%3Crect%20x%3D%22150%22%20y%3D%22112%22%20width%3D%22100%22%20height%3D%22126%22%20rx%3D%2224%22%2F%3E%3Crect%20x%3D%22104%22%20y%3D%22118%22%20width%3D%2234%22%20height%3D%22122%22%20rx%3D%2217%22%2F%3E%3Crect%20x%3D%22262%22%20y%3D%22118%22%20width%3D%2234%22%20height%3D%22122%22%20rx%3D%2217%22%2F%3E%3Crect%20x%3D%22156%22%20y%3D%22230%22%20width%3D%2238%22%20height%3D%22170%22%20rx%3D%2219%22%2F%3E%3Crect%20x%3D%22206%22%20y%3D%22230%22%20width%3D%2238%22%20height%3D%22170%22%20rx%3D%2219%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E';

  const sheet = $('#customSheet');
  const csSport = $('#csSport'), csBrief = $('#csBrief'), csLink = $('#csLink');
  let csRef = null;                       // { kind, name, meta, thumb }

  function csValid() { return csSport.value.trim().length > 0; }
  function csSync() { $('#csGo').disabled = !csValid(); }

  function openCustom(prefill) {
    sheet.classList.add('on');
    $('#csForm').hidden = false;
    $('#csDone').hidden = true;
    if (!state.custom) {
      csSport.value = prefill || sportSearch.value || '';
      csBrief.value = ''; csLink.value = '';
      clearRef();
    }
    csSync();
    setTimeout(() => csSport.focus({ preventScroll: true }), 120);
  }
  function closeCustom() { sheet.classList.remove('on'); }

  $('#openCustom').addEventListener('click', () => openCustom());

  /* Straight past the figures to the size question. */
  $('#skipSport').addEventListener('click', () => {
    state.sport = null; state.sportName = null; state.icons = []; state.sel = null;
    state.custom = null; delete ICONS[CUSTOM_ID];
    renderIcons(); syncIcons(); draw();
    go(ORDER.indexOf('size'));
  });
  $('#csCancel').addEventListener('click', closeCustom);
  $('#csClose').addEventListener('click', closeCustom);
  $('#csEdit').addEventListener('click', () => { $('#csDone').hidden = true; $('#csForm').hidden = false; });
  csSport.addEventListener('input', csSync);

  /* ---- reference: a photo they upload, or a link they paste ---- */
  function refErr(msg) {
    const el = $('#csErr');
    el.textContent = msg || '';
    el.hidden = !msg;
    if (msg) $('#csFile').value = '';
  }

  function clearRef() {
    csRef = null;
    $('#csPrev').hidden = true;
    $('#csFile').value = '';
    csLink.value = '';
  }
  function showRef(r) {
    csRef = r;
    $('#csPrevImg').src = r.thumb || '';
    $('#csPrevName').textContent = r.name;
    $('#csPrevMeta').textContent = r.meta;
    $('#csPrev').hidden = false;
  }
  $('#csPrevClear').addEventListener('click', () => { clearRef(); refErr(null); });

  $('#csFile').addEventListener('change', e => {
    const f = e.target.files && e.target.files[0];
    if (!f) return;
    /* Inline, not alert(): a native dialog on a phone is a full-screen
       system interruption, and it can only say what went wrong. */
    if (!/^image\//.test(f.type)) {
      refErr(t('refType'));
      return;
    }
    if (f.size > 10 * 1024 * 1024) {
      refErr(t('refSize', { mb: num((f.size / 1048576).toFixed(0)) }));
      return;
    }
    refErr(null);
    const fr = new FileReader();
    fr.onload = () => showRef({ kind: 'upload', name: f.name,
      meta: num(Math.round(f.size / 1024)) + ' ' + t('unitKB') + sep() + t('attached'), thumb: fr.result });
    fr.readAsDataURL(f);
  });

  csLink.addEventListener('change', () => {
    const v = csLink.value.trim();
    if (!v) return;
    let host = v;
    try { host = new URL(v).hostname.replace(/^www\./, ''); } catch (e) {}
    showRef({ kind: 'link', name: v, meta: t('linkWord') + sep() + host, thumb: v });
  });

  /* ---- submit ---- */
  $('#csGo').addEventListener('click', () => {
    if (!csValid()) return;
    state.custom = {
      sport: csSport.value.trim(),
      brief: csBrief.value.trim(),
      ref: csRef ? { kind: csRef.kind, name: csRef.name } : null
    };
    ICONS[CUSTOM_ID] = { id: CUSTOM_ID, sport: 'custom',
                         label: state.custom.sport, src: PLACEHOLDER };
    if (state.icons.indexOf(CUSTOM_ID) === -1) {
      if (state.icons.length >= 4) state.icons.pop();
      state.icons.push(CUSTOM_ID);
    }

    $('#csDoneSport').textContent = state.custom.sport;
    $('#csRecap').innerHTML = `<h4>${t('briefTitle')}</h4><dl>
      <div class="r"><dt>${t('bSport')}</dt><dd>${esc(state.custom.sport)}</dd></div>
      <div class="r"><dt>${t('bBrief')}</dt><dd>${esc(state.custom.brief) || `<span style="color:var(--on-ink-dim)">${t('noneGiven')}</span>`}</dd></div>
      <div class="r"><dt>${t('bRef')}</dt><dd>${state.custom.ref
          ? (state.custom.ref.kind === 'upload' ? t('photoRef') : t('linkRef')) + esc(state.custom.ref.name)
          : `<span style="color:var(--on-ink-dim)">${t('none')}</span>`}</dd></div>
    </dl>`;
    $('#csForm').hidden = true;
    $('#csDone').hidden = false;

    if (ORDER[state.step] === 'sport') {
      if (!state.sport) { state.sportName = state.custom.sport; renderIcons(); }
      syncIcons(); draw(); next();
    } else {
      syncIcons(); draw();
    }
  });

  /* ---------------------------------------------------------------
     Sport. One question, not two: a search box over a grouped list.
     A category-then-subcategory pair would add a step and a guess —
     and guessing wrong about which bucket a sport lives in is exactly
     how a customer fails to find something you already sell.
     --------------------------------------------------------------- */
  const sportSearch = $('#sportSearch');
  const sportResults = $('#sportResults');

  const FLAT = [];
  CATALOGUE.forEach(([group, rows]) => rows.forEach(([name, alias, slug]) => {
    const set = slug ? DATA.sports.find(x => x.slug === slug) : null;
    FLAT.push({ group, key: name, get name() { return sportName(this.key); },
                get groupLabel() { return groupName(this.group); },
                alias: alias || '', slug: slug || null,
                n: set ? set.icons.length : 0,
                hay: (name + ' ' + (alias || '')).toLowerCase() });
  }));
  sportSearch.placeholder = t('searchPh', { n: num(FLAT.length) });

  function norm(t) {
    return t.toLowerCase().replace(/[‐-―-]/g, ' ').replace(/\s+/g, ' ').trim();
  }

  /* Rank so that what you typed the beginning of wins. Without this,
     "ping" puts Show jumping above Table tennis. */
  function score(f, q) {
    const n = norm(f.name), a = norm(f.alias);
    if (n.startsWith(q)) return 0;
    if (n.split(' ').some(w => w.startsWith(q))) return 1;
    if (a.split(' ').some(w => w.startsWith(q))) return 2;
    if (n.includes(q)) return 3;
    if (a.includes(q)) return 4;
    return 99;
  }

  function renderSports() {
    const q = norm(sportSearch.value);
    let hits;
    if (q) {
      hits = FLAT.map(f => ({ f, s: score(f, q) }))
                 .filter(x => x.s < 99)
                 .sort((a, b) => a.s - b.s || a.f.name.localeCompare(b.f.name))
                 .map(x => x.f);
    } else {
      hits = FLAT;
    }
    sportResults.textContent = '';

    if (!hits.length) {
      const d = document.createElement('div');
      d.className = 'noresult';
      const typed = sportSearch.value.replace(/[<>&]/g, '');
      d.innerHTML = `${t('noMatch', { q: '<b>“' + typed + '”</b>' })}<br>
        <span style="font-size:.875rem">${t('noMatchSub')}</span>`;
      sportResults.appendChild(d);
      const go = document.createElement('button');
      go.type = 'button';
      go.className = 'btn';
      go.style.cssText = 'width:100%;justify-content:center;margin-top:.4rem';
      go.innerHTML = `${t('haveDrawn', { x: typed ? '“' + typed + '”' : t('itWord') })} <span aria-hidden="true">→</span>`;
      go.addEventListener('click', () => openCustom(sportSearch.value));
      sportResults.appendChild(go);
      return;
    }

    let last = null;
    hits.forEach(f => {
      if (!q && f.group !== last) {
        last = f.group;
        const h = document.createElement('div');
        h.className = 'sgroup';
        h.textContent = f.groupLabel;
        sportResults.appendChild(h);
      }
      const b = document.createElement('button');
      b.className = 'sport';
      b.type = 'button';
      b.setAttribute('role', 'option');

      let label = f.name;
      if (q) {
        const i = norm(f.name).indexOf(q);
        if (i > -1) label = f.name.slice(0, i) + '<mark>' + f.name.slice(i, i + q.length) +
                            '</mark>' + f.name.slice(i + q.length);
      }
      b.innerHTML = `<span class="nm">${label}</span>`
        + (q ? `<span class="tag none" style="border:0;padding-inline-end:.2rem">${f.groupLabel}</span>` : '')
        /* Only say something when there is something to say. In production
           every sport carries figures, so an empty tag would be noise. */
        + (f.n ? `<span class="tag">${figuresN(f.n)}</span>` : '');
      b.addEventListener('click', () => {
        state.sport = f.slug;
        state.sportName = f.n ? null : f.name;   // only flag it when there is nothing to show
        renderIcons();
        next();
      });
      sportResults.appendChild(b);
    });
  }

  sportSearch.addEventListener('input', renderSports);
  sportSearch.addEventListener('keydown', e => {
    if (e.key === 'Enter') {
      const first = sportResults.querySelector('.sport');
      if (first) { e.preventDefault(); e.stopPropagation(); first.click(); }
    }
  });

  /* icons */
  function renderIcons() {
    const area = $('#iconArea');
    area.textContent = '';

    /* A sport that exists in the list but has no artwork yet is its own dead
       end — worse than a failed search, because they think they found it.
       Lead with the offer to draw it rather than burying them in other
       people's sports. */
    if (!state.sport && state.sportName) {
      const box = document.createElement('div');
      box.className = 'promise';
      box.style.marginBottom = '.8rem';
      box.innerHTML = `<b>${t('noArtwork', { s: esc(state.sportName) })}</b><br>${t('noArtworkSub')}`;
      area.appendChild(box);
      const cta = document.createElement('button');
      cta.type = 'button';
      cta.className = 'btn';
      cta.style.cssText = 'width:100%;justify-content:center;margin-bottom:1.4rem';
      cta.innerHTML = `${t('haveDrawn', { x: esc(state.sportName) })} <span aria-hidden="true">→</span>`;
      cta.addEventListener('click', () => openCustom(state.sportName));
      area.appendChild(cta);
    }

    const chosen = DATA.sports.find(s => s.slug === state.sport);
    const groups = [];
    if (chosen) groups.push(chosen);
    /* A composite group — triathlon — is a shortcut to figures that already
       live under their own sports, so it shows only when it is the one asked
       for, never as a second copy further down the page. */
    DATA.sports.forEach(s => { if (s !== chosen && !s.composite) groups.push(s); });

    groups.forEach((g, gi) => {
      const h = document.createElement('div');
      h.className = 'gridhead';
      h.innerHTML = `<span>${setLabel(g)}</span>${gi === 0 && state.sport ? `<span>${t('yourSport')}</span>` : ''}`;
      area.appendChild(h);

      const grid = document.createElement('div');
      grid.className = 'igrid';
      g.icons.forEach(id => {
        const ic = ICONS[id];
        const b = document.createElement('button');
        b.className = 'ibtn';
        b.type = 'button';
        b.setAttribute('aria-pressed', 'false');
        b.setAttribute('aria-label', `${setLabel(g)}: ${iconName(id)}`);
        b.dataset.id = id;
        b.innerHTML = `<span class="pip"></span><img src="${ic.src}" alt=""><span class="cap">${iconName(id)}</span>`;
        b.addEventListener('click', () => toggleIcon(id));
        grid.appendChild(b);
      });
      area.appendChild(grid);
    });
    syncIcons();
  }

  function toggleIcon(id) {
    const at = state.icons.indexOf(id);
    if (at > -1) {
      if (id === CUSTOM_ID) { state.custom = null; delete ICONS[CUSTOM_ID]; }
      state.icons.splice(at, 1);
      /* Removing an item BEFORE the selection shifts everything down, so a
         bare index keeps pointing at a different figure than the one
         highlighted. */
      if (state.sel === at) state.sel = null;
      else if (state.sel !== null && at < state.sel) state.sel -= 1;
    }
    else if (state.icons.length < 4) state.icons.push(id);
    if (state.sel !== null && state.sel >= state.icons.length) state.sel = null;
    syncIcons();
    draw();
  }

  /* ---------------------------------------------------------------
     Order. The figures fill outward from the name — the first half of
     the list stands left, the rest right — so the strip below is a
     literal map of the bar. Moving one along the sequence carries it
     across the name when it passes the middle, which is visible rather
     than explained.
     --------------------------------------------------------------- */
  function leftCount(n) { return Math.ceil(n / 2); }

  /* ---------------------------------------------------------------
     The row of chosen figures. It is a small map of the bar itself:
     figures to the left of the name, the name, figures to the right.

     Every control lives ON the figure — ✕ to take it off, ‹ › to move it
     along the bar — and is visible from the start. The old version asked
     you to tap a figure first and then find a toolbar that appeared
     somewhere else, which is a step nobody guesses.
     --------------------------------------------------------------- */
  function moveIcon(i, d) {
    const j = i + d;
    if (j < 0 || j >= state.icons.length) return;
    const tmp = state.icons[i];
    state.icons[i] = state.icons[j];
    state.icons[j] = tmp;
    state.sel = null;
    syncIcons();
    draw();
  }

  function removeIcon(i) {
    const id = state.icons[i];
    /* If the figure being removed is the one we promised to draw, the
       request goes with it. */
    if (id === CUSTOM_ID) { state.custom = null; delete ICONS[CUSTOM_ID]; }
    state.icons.splice(i, 1);
    state.sel = null;
    syncIcons();
    draw();
  }

  /* An empty place in the strip is a way to the figures, not a figure: it
     brings the grid into view and leaves the choosing to the customer. The
     grid starts with the sport they searched for, so that is what shows. */
  function showFigures() {
    const area = $('#iconArea');
    if (!area) return;
    area.scrollIntoView({ block: 'start', behavior: REDUCED.matches ? 'auto' : 'smooth' });
    const first = area.querySelector('.ibtn[aria-pressed="false"]:not(:disabled)');
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) {} }
  }

  function renderStrip() {
    const strip = $('#strip');
    const tools = $('#striptools');
    strip.textContent = '';
    tools.textContent = '';

    const n = state.icons.length;
    const nL = leftCount(n);

    function ctl(sign, cls, label, enabled, fn) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = cls;
      b.textContent = sign;
      b.setAttribute('aria-label', label);
      b.disabled = !enabled;
      if (enabled) b.addEventListener('click', fn);
      return b;
    }

    function tile(i) {
      const id = state.icons[i];
      const label = iconName(id);
      const col = document.createElement('div');
      col.className = 'tile';

      const box = document.createElement('div');
      box.className = 'tile-box';
      const img = document.createElement('img');
      img.src = ICONS[id].src;
      img.alt = '';
      if (id === CUSTOM_ID) img.style.opacity = '.5';
      box.appendChild(img);
      box.appendChild(ctl('×', 'tile-x', t('removeFig', { x: label }), true,
        function () { removeIcon(i); }));
      if (id === CUSTOM_ID) {
        const tag = document.createElement('span');
        tag.className = 'sketchtag';
        tag.textContent = t('toDraw');
        box.appendChild(tag);
      }
      col.appendChild(box);

      const cap = document.createElement('span');
      cap.className = 'tile-cap';
      cap.textContent = label;
      col.appendChild(cap);

      /* The two arrows sit under their own figure rather than between
         figures, so a tap can never land on the neighbour's control. */
      const nav = document.createElement('div');
      nav.className = 'tile-nav';
      nav.appendChild(ctl('‹', 'tile-move', t('moveLeft', { x: label }), i > 0,
        function () { moveIcon(i, -1); }));
      nav.appendChild(ctl('›', 'tile-move', t('moveRight', { x: label }), i < n - 1,
        function () { moveIcon(i, 1); }));
      col.appendChild(nav);
      return col;
    }

    function namePill() {
      const pill = document.createElement('span');
      pill.className = 'namepill' + (state.name ? '' : ' none');
      pill.textContent = state.name || t('yourName');
      if (state.name) {
        pill.style.fontFamily = (FONTS.find(f => f.id === state.font) || FONTS[0]).css;
        if ((FONTS.find(f => f.id === state.font) || {}).rtl) pill.setAttribute('dir', 'rtl');
      }
      return pill;
    }

    /* Four places, always: two either side of the name, as the bar has room
       for. Chosen figures stand against the name in the order they stand on
       the bar; the places still free are dashed boxes on the outside, so the
       strip shows there is room for more before anyone has to ask. */
    function slot() {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'tile tile--empty';
      b.setAttribute('aria-label', t('addFigure'));
      const box = document.createElement('span');
      box.className = 'tile-box';
      const plus = document.createElement('span');
      plus.setAttribute('aria-hidden', 'true');
      plus.textContent = '+';
      box.appendChild(plus);
      b.appendChild(box);
      b.addEventListener('click', showFigures);
      return b;
    }

    for (let k = nL; k < 2; k++) strip.appendChild(slot());
    for (let i = 0; i < nL; i++) strip.appendChild(tile(i));
    strip.appendChild(namePill());
    for (let i = nL; i < n; i++) strip.appendChild(tile(i));
    for (let k = n - nL; k < 2; k++) strip.appendChild(slot());

    const tip = document.createElement('span');
    tip.className = 'tip';
    tip.textContent = n ? t('stripTip') : t('stripTipEmpty');
    tools.appendChild(tip);
  }


  function syncIcons() {
    $$('.ibtn').forEach(b => {
      const at = state.icons.indexOf(b.dataset.id);
      b.setAttribute('aria-pressed', String(at > -1));
      b.querySelector('.pip').textContent = at > -1 ? num(at + 1) : '';
      b.disabled = at === -1 && state.icons.length >= 4;
      b.style.opacity = b.disabled ? .38 : 1;
    });
    renderStrip();
    const n = state.icons.length;
    $('#iconCount').textContent = n ? t('chosen', { n: num(n) }) : t('chosenNone');
    /* Zero figures is a real product — "Name Only" is on the store, and
       `blank` is a figure in the library. The button says so rather than
       sitting disabled. */
    $('#iconNext').innerHTML = (n ? t('ok') : t('nameOnly')) + ' <span aria-hidden="true">→</span>';
  }

  /* size */
  const sizeList = $('#sizeList');
  function buildSizes() {
  sizeList.textContent = '';
  SIZES.forEach((s, i) => {
    const b = document.createElement('button');
    b.className = 'choice';
    b.type = 'button';
    b.setAttribute('role', 'radio');
    b.setAttribute('aria-checked', String(s.id === state.size));
    b.innerHTML = `<span class="key">${String.fromCharCode(65 + i)}</span>
                   <span class="txt">${sizeLabel(s.label)}<span class="note">${s.note}${s.price ? sep() + '<bdi>' + s.price + '</bdi>' : ''}</span></span>`;
    b.addEventListener('click', () => {
      state.size = s.id;
      Array.from(sizeList.children).forEach(c => c.setAttribute('aria-checked', String(c === b)));
      draw();
      setTimeout(next, 190);
    });
    sizeList.appendChild(b);
  });
  }
  buildSizes();

  /* colour */
  const colourList = $('#colourList');
  function buildColours() {
  colourList.textContent = '';
  COLOURS.forEach(c => {
    const b = document.createElement('button');
    b.className = 'sw';
    b.type = 'button';
    b.setAttribute('role', 'radio');
    b.setAttribute('aria-checked', String(c.id === state.colour));
    b.innerHTML = `<i style="background:${c.hex}"></i><span>${c.label}</span>`;
    b.addEventListener('click', () => {
      state.colour = c.id;
      Array.from(colourList.children).forEach(x => x.setAttribute('aria-checked', String(x === b)));
      draw();
    });
    colourList.appendChild(b);
  });
  }
  buildColours();

  /* Pieces of a name that never reach the baseline — the dot on a j, the
     hyphen, the dots and hamzas of Arabic. The baseline sits inside the
     steel, so everything standing on it is welded; these are not, and a
     designer bridges each one to the letter it belongs to before the file
     goes to the laser. Which characters do this is a property of the face,
     measured off its outlines by measure_stroke.js, so counting them here
     is a string scan rather than a geometry job. */
  function looseMarks(name, fontId) {
    /* The Arabic face is cut as a stencil: its dots and hamzas are holes in
       the steel, not pieces to bridge, so there is nothing to count. */
    if (fontId === 'arabic') return 0;
    const table = (STROKE[fontId] || {}).marks || {};
    let n = 0;
    for (const ch of String(name || '')) n += table[ch] || 0;
    return n;
  }

  /* summary */
  function renderSummary() {
    const size = SIZES.find(s => s.id === state.size);
    const col = COLOURS.find(c => c.id === state.colour);
    const rows = [
      [t('sText'), esc(state.name) || '—'],
      [t('sLettering'), (FONTS.find(f => f.id === state.font) || FONTS[0]).label],
      [t('sFigures'), state.icons.map(i => esc(iconName(i))).join(listSep()) || '—'],
      [t('sSize'), sizeLabel(size.label)],
      [t('sFinish'), t('powder', { c: col.label })],
      [t('sDelivery'), t('sDeliveryValue')]
    ];
    $('#summary').innerHTML = rows.map(([k, v]) =>
      `<div class="srow"><dt>${k}</dt><dd>${v}</dd></div>`).join('')
      + `<div class="srow total"><dt>${t('sTotal')}</dt><dd>${priceFor(state.size, state.colour) || '—'}</dd></div>`;

    const briefBox = $('#briefBox');
    const marks = looseMarks(state.name, state.font);
    const markRow = marks
      ? `<div class="r"><dt>${t('bridging')}</dt><dd>${t('bridgingText', { n: num(marks) })}</dd></div>`
      : '';
    /* Key off the figure actually being on the bar, not merely on the
       request having once been made. */
    if (state.custom && state.icons.indexOf(CUSTOM_ID) > -1) {
      const at = state.icons.indexOf(CUSTOM_ID);
      briefBox.hidden = false;
      briefBox.innerHTML = `<h4>${t('briefTitle')}</h4><dl>
        <div class="r"><dt>${t('bSport')}</dt><dd>${esc(state.custom.sport)}</dd></div>
        <div class="r"><dt>${t('bBrief')}</dt><dd>${esc(state.custom.brief) || `<span style="color:var(--on-ink-dim)">${t('noneGiven')}</span>`}</dd></div>
        <div class="r"><dt>${t('bRef')}</dt><dd>${state.custom.ref
            ? (state.custom.ref.kind === 'upload' ? t('photoRef') : t('linkRef')) + esc(state.custom.ref.name)
            : `<span style="color:var(--on-ink-dim)">${t('none')}</span>`}</dd></div>
        <div class="r"><dt>${t('bPosition')}</dt><dd>${t('bPositionValue', { side: at < leftCount(state.icons.length) ? t('sideLeft') : t('sideRight'), i: num(at + 1), n: num(state.icons.length) })}</dd></div>
        <div class="r"><dt>${t('bStatus')}</dt><dd>${t('bStatusValue')}</dd></div>
        ${markRow}
      </dl>`;
    } else if (markRow) {
      briefBox.hidden = false;
      briefBox.innerHTML = `<h4>${t('briefTitle')}</h4><dl>${markRow}</dl>`;
    } else {
      briefBox.hidden = true;
    }
  }

  $('#restart').addEventListener('click', () => {
    state.name = ''; state.icons = []; state.sport = null; state.sel = null;
    state.fontLocked = false; setFont('deco', false);
    state.custom = null; csRef = null; delete ICONS[CUSTOM_ID];
    state.size = '104'; state.colour = 'black';
    nameInput.value = '';
    $('#nameCount').hidden = true;
    $('#nameCount').textContent = '';
    $('#nameCount').classList.remove('warn');
    hideScriptHint();
    refreshChipSamples();
    sportSearch.value = ''; renderSports();
    $('#nameNext').disabled = true;
    sportSearch.value = '';
    state.sportName = null;
    Array.from(colourList.children).forEach((c, i) => c.setAttribute('aria-checked', String(i === 0)));
    Array.from(sizeList.children).forEach((c, i) => c.setAttribute('aria-checked', String(i === 0)));
    renderIcons(); draw(); go(0);
  });

  /* keyboard: Enter advances, letter keys pick options */
  document.addEventListener('keydown', e => {
    const key = ORDER[state.step];
    if (e.key === 'Enter') {
      const active = document.activeElement;
      if (active && (active.classList.contains('choice') || active.classList.contains('ibtn') || active.classList.contains('sw'))) return;
      e.preventDefault();
      const btn = $('.step.on [data-next]') || $('.step.on .btn');
      if (btn && !btn.disabled) btn.click();
      return;
    }
    if (e.key === 'Escape') { back(); return; }
    if (/^[a-z]$/i.test(e.key) && key === 'size') {
      if (document.activeElement === nameInput) return;
      const list = sizeList;
      const idx = e.key.toUpperCase().charCodeAt(0) - 65;
      if (list.children[idx]) { e.preventDefault(); list.children[idx].click(); }
    }
  });

  /* Every measurement on this page — how tall the ink is, how deep the
     descenders go, how wide the word runs — is taken from the rendered
     face. Until the face has loaded those numbers describe a fallback, so
     ask for each cutting face by name and redraw when they are all in.
     document.fonts.ready alone is not enough: a face nothing has drawn yet
     is not "pending", so ready can resolve before the real one arrives. */
  if (document.fonts && document.fonts.load) {
    Promise.all(FONTS.map(f =>
      document.fonts.load('700 100px ' + f.css, f.sample).catch(() => {})
    )).then(() => {
      for (const k in _mcache) delete _mcache[k];
      draw();
    });
  }

  /* ---------------------------------------------------------------
     The cart. Everything the workshop needs travels as line item
     properties, under the same names Product Personalizer used, so the
     order sheets and the designer's habits keep working. The preview
     image goes up the same way a customer upload does — as a file on the
     cart form — which is why no app is needed to attach it.
     --------------------------------------------------------------- */
  const LETTERING_EN = { deco: 'Deco', script: 'Script', arabic: 'Arabic' };

  const addBtn = $('#mhAdd');
  const addPrice = $('#mhAddPrice');
  const errBox = $('#mhErr');

  function showErr(msg) {
    errBox.textContent = msg;
    errBox.hidden = false;
  }

  function iconLabel(id) {
    if (id === CUSTOM_ID) {
      return 'Custom figure: ' + (state.custom ? state.custom.sport : 'to be drawn');
    }
    return (ICONS[id] || {}).label || id;   // English: the workshop reads this
  }

  /* The faces are loaded from Google and from the theme, but an SVG handed
     to an <img> is its own document and may not fetch anything. So the
     outlines are pulled down once, turned into data URIs, and carried
     inside the copy that gets rasterised — otherwise the picture attached
     to the order would show a typeface the laser never cuts. */
  const _faceCache = {};
  function asDataUrl(blob) {
    return new Promise(function (res, rej) {
      const fr = new FileReader();
      fr.onload = function () { res(fr.result); };
      fr.onerror = rej;
      fr.readAsDataURL(blob);
    });
  }
  async function faceCss(fontId) {
    if (_faceCache[fontId] !== undefined) return _faceCache[fontId];
    let out = '';
    try {
      if (fontId === 'deco') {
        const url = (SHOP.fonts || {}).marquisette;
        if (url) {
          const d = await asDataUrl(await fetch(url).then(function (r) { return r.blob(); }));
          out = '@font-face{font-family:"Marquisette BTN";font-weight:700;'
              + 'src:url(' + d + ') format("woff2")}';
        }
      } else {
        const q = fontId === 'script' ? 'family=Pacifico' : 'family=Cairo:wght@700';
        const css = await fetch('https://fonts.googleapis.com/css2?' + q).then(function (r) { return r.text(); });
        const blocks = css.match(/@font-face\s*\{[^}]*\}/g) || [];
        for (const b of blocks) {
          const u = (b.match(/url\((https:[^)]+\.woff2)\)/) || [])[1];
          if (!u) continue;
          const d = await asDataUrl(await fetch(u).then(function (r) { return r.blob(); }));
          out += b.replace(/url\(https:[^)]+\.woff2\)/, 'url(' + d + ')');
        }
      }
    } catch (e) { out = ''; }
    _faceCache[fontId] = out;
    return out;
  }

  /* A picture of the hanger, black on white, at the proportions of the cut. */
  async function previewPng() {
    const vb = svg.getAttribute('viewBox').split(/\s+/).map(Number);
    const clone = svg.cloneNode(true);
    const st = document.createElementNS('http://www.w3.org/2000/svg', 'style');
    st.textContent = await faceCss(state.font);
    clone.insertBefore(st, clone.firstChild);
    clone.querySelectorAll('[filter]').forEach(function (e) { e.removeAttribute('filter'); });
    clone.querySelectorAll('#barPath, #nameText, #mhArBand').forEach(function (e) { e.setAttribute('fill', '#000'); });
    /* The stencil's outline is the name's stroke; its holes come from the
       mask, which travels in the clone's defs. */
    const nt = clone.querySelector('#nameText');
    if (nt && nt.getAttribute('stroke')) nt.setAttribute('stroke', '#000');

    const W = 1600, H = Math.max(1, Math.round(1600 * vb[3] / vb[2]));
    clone.setAttribute('width', W);
    clone.setAttribute('height', H);

    const img = new Image();
    await new Promise(function (res, rej) {
      img.onload = res;
      img.onerror = function () { rej(new Error('preview')); };
      img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(
        new XMLSerializer().serializeToString(clone))));
    });
    const cv = document.createElement('canvas');
    cv.width = W; cv.height = H;
    const ctx = cv.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, W, H);
    ctx.drawImage(img, 0, 0);
    return new Promise(function (res) { cv.toBlob(res, 'image/png'); });
  }

  async function addToCart() {
    errBox.hidden = true;
    const v = variantFor(state.size, state.colour);
    if (!v) { showErr(t('errVariant')); return; }
    if (!String(state.name || '').trim() && !state.icons.length) {
      showErr(t('errEmpty')); return;
    }

    const label = addBtn.innerHTML;
    addBtn.disabled = true;
    addBtn.textContent = t('adding');

    const fd = new FormData();
    fd.append('id', v.id);
    fd.append('quantity', '1');
    fd.append('properties[Name]', state.name);
    fd.append('properties[Lettering]', LETTERING_EN[state.font] || state.font);

    const cut = leftCount(state.icons.length);
    state.icons.slice(0, cut).forEach(function (id, i) {
      fd.append('properties[Left Icon ' + (i + 1) + ']', iconLabel(id));
    });
    state.icons.slice(cut).forEach(function (id, i) {
      fd.append('properties[Right Icon ' + (i + 1) + ']', iconLabel(id));
    });
    if (state.custom) {
      if (state.custom.brief) fd.append('properties[Custom figure brief]', state.custom.brief);
      if (state.custom.ref) {
        fd.append('properties[Custom figure reference]',
          (state.custom.ref.kind === 'upload' ? 'Photo: ' : 'Link: ') + state.custom.ref.name);
      }
    }

    try {
      const png = await previewPng();
      if (png) fd.append('properties[Preview]', png, 'hanger-preview.png');
    } catch (e) { /* the order still carries every choice in words */ }

    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST', body: fd, headers: { Accept: 'application/json' }
      });
      if (!r.ok) {
        const j = await r.json().catch(function () { return {}; });
        throw new Error(j.description || j.message || t('errCart'));
      }
      window.location.href = '/cart';
    } catch (e) {
      addBtn.disabled = false;
      addBtn.innerHTML = label;
      showErr(e.message || t('errCart'));
    }
  }

  if (addBtn) addBtn.addEventListener('click', addToCart);

  /* Keep the button's price honest as the size and finish change. */
  const _renderSummary = renderSummary;
  renderSummary = function () {
    _renderSummary();
    if (addPrice) addPrice.textContent = priceFor(state.size, state.colour) || '';
    const v = variantFor(state.size, state.colour);
    if (addBtn) {
      addBtn.disabled = !v;
      if (!v) showErr(t('errVariant'));
    }
  };

  /* Pin-and-shrink for the preview on a phone. The root carries --p, a
     0..1 progress: 0 with the builder at the top of the viewport, 1 once the
     stage has scrolled up to its pinned strip, which is 132 px short of its
     own height. The stylesheet turns that into the transform and the fades.
     A continuous value rather than a threshold, so there is no boundary for
     the scroll position to oscillate across. Passive and frame-throttled;
     on desktop it is pinned at 0 and nothing reads it. */
  function initScroll() {
    let queued = false, range = 0, last = -1;
    const STAGE = ROOT.querySelector('.stage');
    const measure = function () {
      rootTop = Math.round(ROOT.getBoundingClientRect().top + window.scrollY);
      range = STAGE ? STAGE.getBoundingClientRect().height - 132 : 0;
    };
    const update = function () {
      queued = false;
      let p = 0;
      if (MOBILE.matches && range > 0) {
        p = (window.scrollY - rootTop) / range;
        p = p < 0 ? 0 : p > 1 ? 1 : p;
      }
      /* Skip writes that would not show; always land the two ends exactly. */
      if (Math.abs(p - last) <= 0.002 && p !== 0 && p !== 1) return;
      if (p === last) return;
      last = p;
      ROOT.style.setProperty('--p', p.toFixed(3));
    };
    const onScroll = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    };
    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); onScroll(); }, { passive: true });
    window.addEventListener('load', function () { measure(); onScroll(); });
    if (MOBILE.addEventListener) MOBILE.addEventListener('change', function () { measure(); update(); });
    update();
  }

  initLang();
  renderSports();
  renderIcons();
  draw();
  go(0);
  initScroll();
};
